import React from 'react';
import { Link } from 'react-router-dom';
import LegalPageLayout from './LegalPageLayout';

export default function PrivacyPolicy() {
  return (
    <LegalPageLayout title="Privacy Policy" testId="rwm-privacy-policy">
      <p>
        RemoteWorkMarket.com is operated by ONG IT Solutions, based in the Netherlands. This
        Privacy Policy explains how we collect, use, store, and protect personal data when you
        use our remote job board platform — whether you are a company posting listings or a
        candidate browsing and applying for roles.
      </p>

      <h2>Information We Collect</h2>
      <ul>
        <li>
          <strong>Account information</strong> — name, email address, and password hash when you
          register.
        </li>
        <li>
          <strong>Company information</strong> — company name, address, and VAT ID for employers
          completing onboarding.
        </li>
        <li>
          <strong>CV and cover letters</strong> — uploaded by candidates only; stored securely on
          private servers and accessible only to the hiring company.
        </li>
        <li>
          <strong>Usage data</strong> — IP address, browser type, and pages visited for security
          and platform improvement.
        </li>
      </ul>

      <h2>How We Use Your Information</h2>
      <ul>
        <li>To provide the platform — job listings, applications, and account management.</li>
        <li>To send transactional emails — email verification, application notifications, and billing receipts.</li>
        <li>
          To process payments via Stripe — we do not store card data; Stripe handles payment
          processing securely.
        </li>
        <li>To comply with legal obligations under Dutch and EU law.</li>
      </ul>

      <h2>Data Retention</h2>
      <ul>
        <li>
          <strong>Account data</strong> — retained until you delete your account.
        </li>
        <li>
          <strong>Application data</strong> — anonymized after 12 months.
        </li>
        <li>
          <strong>Payment records</strong> — retained for 7 years in accordance with Dutch tax law.
        </li>
        <li>
          <strong>IP logs</strong> — retained for 90 days.
        </li>
      </ul>

      <h2>Your Rights (GDPR)</h2>
      <p>
        Under the General Data Protection Regulation, you have the right to access, rectify, erase,
        port, and object to the processing of your personal data.
      </p>
      <ul>
        <li>
          To exercise your rights, contact us at{' '}
          <a href="mailto:privacy@remoteworkmarket.com">privacy@remoteworkmarket.com</a>.
        </li>
        <li>
          You also have the right to lodge a complaint with the Dutch Data Protection Authority
          (Autoriteit Persoonsgegevens) at{' '}
          <a href="https://autoriteitpersoonsgegevens.nl" target="_blank" rel="noopener noreferrer">
            autoriteitpersoonsgegevens.nl
          </a>
          .
        </li>
      </ul>

      <h2>Cookies</h2>
      <p>
        We use essential cookies by default to keep the platform functioning. Analytics cookies
        (Google Analytics 4) are only set after you give consent. See our{' '}
        <Link to="/cookies">Cookie Policy</Link> for full details.
      </p>

      <h2>Third-Party Services</h2>
      <ul>
        <li>
          <strong>Stripe</strong> — payment processing
        </li>
        <li>
          <strong>SendGrid</strong> — transactional email delivery
        </li>
        <li>
          <strong>Google Analytics</strong> — website analytics (opt-in only)
        </li>
        <li>
          <strong>Hostinger</strong> — hosting infrastructure
        </li>
      </ul>

      <h2>Contact</h2>
      <p>
        For privacy-related questions, contact{' '}
        <a href="mailto:privacy@remoteworkmarket.com">privacy@remoteworkmarket.com</a>.
      </p>
      <p className="mb-0">ONG IT Solutions, Netherlands</p>
    </LegalPageLayout>
  );
}
